import { IconName, TipPlacement, Tooltip } from '@focaldata/cin-ui-components'
import { QuestionnaireHeaderChip } from '../HeaderLabels/QuestionnaireHeaderChip'
import useStyles from './KpiChip.styles'
import { useKpi } from './KpiProvider'
import { getKpiName } from './kpi.utils'

const KpiChip = () => {
  const kpi = useKpi()
  const { classes } = useStyles()

  if (!kpi || kpi.kpis.length === 0) {
    return null
  }

  const { kpis } = kpi
  const label = kpis[0].label?.trim()
  const single = label ? `KPI · ${label}` : 'KPI'
  const text = kpis.length === 1 ? single : `${kpis.length} KPIs`

  return (
    <Tooltip
      title={
        <span className={classes.names}>
          {kpis.map((item, index) => (
            <span key={item.kpiId}>{getKpiName(item, index, kpis.length)}</span>
          ))}
        </span>
      }
      tipPlacement={TipPlacement.Bottom}
      childrenWrapperStyle={{
        display: 'inline-flex',
        minWidth: 0,
        maxWidth: '100%'
      }}
    >
      <QuestionnaireHeaderChip iconName={IconName.Kpi} data-testid="kpi-chip">
        {text}
      </QuestionnaireHeaderChip>
    </Tooltip>
  )
}

export default KpiChip
